/**
 * Register the service worker for installability + offline shell.
 * Only registers in production-style URLs (https / non-localhost),
 * avoids unexpected SW caches blocking dev hot-reload.
 */
export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;

  const isLocal =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1";

  // Skip on plain http localhost dev; allow everywhere else.
  if (isLocal && window.location.protocol !== "https:") return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .catch(() => {
        /* silent — SW is a nice-to-have */
      });
  });
}
